import { Box, MenuItem, Select } from "@mui/material";
import { useState } from "react";

const countries = [
  { name: "Eng (US)", flag: "https://flagcdn.com/w40/us.png" },
  { name: "United Kingdom", flag: "https://flagcdn.com/w40/gb.png" },
  { name: "Germany", flag: "https://flagcdn.com/w40/de.png" },
  { name: "France", flag: "https://flagcdn.com/w40/fr.png" },
  { name: "Canada", flag: "https://flagcdn.com/w40/ca.png" },
  { name: "Japan", flag: "https://flagcdn.com/w40/jp.png" },
  { name: "India", flag: "https://flagcdn.com/w40/in.png" },
];
function SelectLanguageComponent({ marginTop = "70px" }) {
  const [selectedCountry, setSelectedCountry] = useState("Eng (US)");
  return (
    <Select
      value={selectedCountry}
      onChange={(event) => setSelectedCountry(event.target.value)}
      sx={{
        border: "3px solid #e6e6e6",
        mt: marginTop,
        color: "#8c8c8c",
        borderRadius: "16px",
        p: 0, // Removes internal padding
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none", // Removes default border
        },
        "&.MuiOutlinedInput-root": {
          p: 0, // Removes padding from the root div
          width: "max-content",
          pr: "12px",
        },
        "& .MuiSelect-select": {
          p: "10px", // Controls internal padding of the selected value
          px: "18px",
        },
        "&:focus, &.Mui-focused, &:hover": {
          outline: "none",
          border: "3px solid #e6e6e6",
          boxShadow: "none",
        },
      }}
    >
      {countries.map((country, index) => (
        <MenuItem key={index} value={country.name}>
          <Box display="flex" alignItems="center" sx={{ color: "#8c8c8c" }}>
            <img
              src={country.flag}
              alt={country.name}
              width="30"
              height="30"
              style={{ marginRight: 10, borderRadius: "50%" }}
            />
            {country.name}
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
}

export default SelectLanguageComponent;
